import { lazy, Suspense } from 'react';

const LazyLoadingBar = lazy(() => import('./loading-bar'));

export default function LoadingBar() {
    return <Suspense fallback={null}>
        <LazyLoadingBar />
    </Suspense>;
}
